import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    // console.log('MobileGuard canActivate')
    // Check user agent for mobile devices
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    
    // Check screen size
    const isMobileScreen = window.innerWidth < 650;
    
    const isMobile = isMobileUserAgent || isMobileScreen;    
    if (isMobile) {
      return true;
    }
    
    // For desktop, redirect to kiln-list
    this.router.navigate(['/kiln-list']);
    return false;    
  }
}
